import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Car, FileText, Shield, ArrowRight } from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      icon: Car,
      title: 'PCP Claims',
      description: 'Were you charged hidden commission on your PCP car finance? You may be entitled to compensation if commission was not properly disclosed.',
      href: '/pcp-car-finance-claims',
      color: 'text-accent'
    },
    {
      icon: FileText,
      title: 'HP Claims',
      description: 'Hire Purchase agreements may also have included undisclosed commission. We can help assess whether your HP finance was mis-sold.',
      href: '/pcp-car-finance-claims',
      color: 'text-gold'
    },
    {
      icon: Shield,
      title: 'GAP Insurance Claims',
      description: 'GAP insurance sold alongside your car finance may have been mis-sold. The FCA is scrutinising how GAP products were sold to consumers.',
      href: '/gap-insurance-claims',
      color: 'text-accent'
    }
  ];

  return (
    <section id="services" className="py-20 lg:py-28 bg-background">
      <div className="section-container">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-sm font-semibold text-accent uppercase tracking-wider mb-4">
            Our Services
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            PCP, HP and GAP Insurance Claims
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Blue Lion Law assists clients with claims relating to PCP car finance mis-selling, 
            HP car finance mis-selling, and mis-sold GAP insurance sold alongside vehicle finance. 
            Eligibility depends on individual circumstances.
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card 
              key={index}
              className="group border-border hover:border-accent/50 transition-all duration-300 hover:shadow-xl"
            >
              <CardContent className="p-8">
                {/* Icon */}
                <div className={`w-14 h-14 rounded-xl bg-muted flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <service.icon className={`w-7 h-7 ${service.color}`} />
                </div>

                {/* Content */}
                <h3 className="font-heading text-xl font-bold text-foreground mb-3">
                  {service.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* CTA */}
                <Button variant="outline" className="w-full group-hover:bg-accent group-hover:text-accent-foreground group-hover:border-accent transition-all" asChild>
                  <a href={service.href}>
                    Learn More
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </a>
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Note */}
        <div className="mt-12 text-center">
          <p className="text-sm text-muted-foreground">
            <Shield className="w-4 h-4 inline mr-2" />
            Blue Lion Law Limited is authorised and regulated by the Solicitors Regulation Authority (SRA No: 815166)
          </p>
        </div>
      </div>
    </section>
  );
};

export { ServicesSection };
